// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Benefit_wrapper__pVxTB","benefitIcon":"Benefit_benefitIcon__p9_n0","benefitTitle":"Benefit_benefitTitle__IwP_L","benefitDescription":"Benefit_benefitDescription___YEtz"};